import React,{useState,useEffect} from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import gal2 from "../../images/gal2.JPG"
import gal3 from "../../images/gal3.JPG"
import hotel from "../../images/hotel.JPG"
import birthday from "../../images/birthday2.JPG"
import banquet from "../../images/banquet.jpg"
import marrige from "../../images/marrige_reception.JPG"
import "./gallery.css";

// import required modules
import { EffectCoverflow, Pagination } from "swiper";
const images=[hotel,birthday,banquet,marrige,gal2,gal3]
export const Flow = (props)=> {
const [slidePerView,setSlidePerView]=useState(3);
  // const [width,setWidth]=useState("900px");
  // const [height,setHeight]=useState("500px");
    useEffect(() => {
        if (window.innerWidth<600)
    setSlidePerView(1);
    else if (window.innerWidth<1300)
    setSlidePerView(2);
    // if (window.innerWidth< 1300 && window.innerWidth>600)
    // {
    //   setWidth("600px");
    // setHeight("400px")
    // }
    // else if (window.innerWidth < 600){
    // setWidth(window.innerWidth);
    // }
    },[window.innerWidth])

      

 return (
    <div className="container md:w-4/5 mx-auto pb-10 w-full">
        <Swiper
         style={{
          "--swiper-navigation-color": "#d2a960",
          "--swiper-pagination-color": "#d2a960",
  padding:"20px"}}
        effect={"coverflow"}
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={slidePerView}
        coverflowEffect={{
          rotate: props.rotate,
          stretch: 0,
          depth:props.depth,
          modifier: 1,
          slideShadows: true,
        }}
        loop={true}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[EffectCoverflow, Pagination]}
        className="mySwiper"
      >
        {images.map((gal,i)=>{
          return(<SwiperSlide key={i} style={{backgroundColor:"transparent"}}
          ><img className="bg-cover bg-center" src={gal} alt="bg"/></SwiperSlide>
          )})}
    
      
      </Swiper>
    </div>
  );
}
export default Flow;